import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Media from './components/Media';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Index from './components/Index';
import AppSection from './components/AppSection';
import Carousel from './components/Carousel';
import Features from './components/Features';
import Faq from './components/Faq';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Contact />
        <Updates />
        <Media />
        <Comments />
        <Topics />
        <Index />
        <AppSection />
        <Carousel />
        <Features />
        <Faq />
        <Cards />
        <Ranking />
      </main>
      <Footer />
    </>
  );
}